import React from 'react';
import {
    Table,
    Row,
    Spin,
    Button,
    Popconfirm,
    Pagination,
} from 'antd';

import { asyncGet, reStart, actions } from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
import Edit from './edit.js';
import SetOrder from './setOrder.js';
import SetGroup from './setGroup.js';
import moment from 'moment';
import EditVersion from './editVersion.js';
import EditAppList from './editAppList.js';
class AgencyAnalysis extends React.Component {
    state = {
        selectedRowKeys: [],
    };
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };
    /**
     * 分页器改变数据处理
     */
    handlePaginationChange = (current, pageSize) => {
        let pagination = {
            current,
            pageSize,
        };
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };

    reStart = record => {
        const {clientId} = record;
        this.props.reStart({clientIds: [clientId], action: '7', executeNow: true});
        this.props.asyncGet();
    }

    edit = record => {
        this.props.editShow();
        this.props.changeCurrentSelectId(record.clientId);
    }

    renderAction = (text, record) => {
        // console.log(expanded, record);
        return (
            <div>
                <Button type="primary" style={{ marginRight: '5px' }} size="small" onClick={() => {
                    this.edit(record);
                }}>
                    编辑
                </Button>
                <Popconfirm
                    title='确认重启'
                    okText='确定'
                    cancelText='取消'
                    onConfirm={() => {
                        this.reStart(record);
                    }}>
                    <Button type="danger" style={{ marginRight: '5px' }} size="small">
                        重启
                    </Button>
                </Popconfirm>
            </div>
        );
    };

    onSelectChange = selectedRowKeys => {
        this.props.getTransferData({ selectedRowKeys });
    }

    render() {
        let { list, uiStatus, pagination, transferData } = this.props;
        let { total, current, pageSize } = pagination;
        let totalPage = Math.ceil(total / pageSize);
        const { selectedRowKeys } = transferData;
        let { isLoading } = uiStatus;

        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };

        const columns = [
            {
                title: '设备ID',
                dataIndex: 'clientId',
                key: 'clientId',
            },
            {
                title: '架子ID',
                dataIndex: 'shelfId',
                key: 'shelfId',
                sorter: (a, b) => a.shelfId - b.shelfId,
            },
            {
                title: '搜索ID',
                dataIndex: 'searchId',
                key: 'searchId',
                sorter: (a, b) => a.searchId - b.searchId,
            },
            {
                title: '设备类型',
                dataIndex: 'os',
                key: 'os',
            },
            {
                title: '横坐标',
                dataIndex: 'x',
                key: 'x',
                sorter: (a, b) => a.x - b.x,
            },
            {
                title: '纵坐标',
                dataIndex: 'y',
                key: 'y',
                sorter: (a, b) => a.y - b.y,
            },
            {
                title: '版本号',
                dataIndex: 'appv',
                key: 'appv',
                sorter: (a, b) => a.appv - b.appv,
            },
            {
                title: '目标版本号',
                dataIndex: 'targetVersion',
                key: 'targetVersion',
                sorter: (a, b) => a.targetVersion - b.targetVersion,
            },
            {
                title: '设备状态',
                dataIndex: 'onLine',
                key: 'onLine',
                render: text => {
                    return text === 0 ? '下架' : (text === 1 ? '在线' : '掉线');
                },
            },
            {
                title: '上线时间',
                dataIndex: 'createTime',
                key: 'createTime',
                render: text => {
                    return text ? moment(parseInt(text)).format('YYYY-MM-DD HH:mm:ss') : '';
                },
            },
            {
                title: '最后上报时间',
                dataIndex: 'lastUpdateTimeStamp',
                key: 'lastUpdateTimeStamp',
                render: text => {
                    return text ? moment(parseInt(text)).format('YYYY-MM-DD HH:mm:ss') : '';
                },
            },
            {
                title: '最后取任务时间',
                dataIndex: 'lastRegistTimeStamp',
                key: 'lastRegistTimeStamp',
                render: text => {
                    return text ? moment(parseInt(text)).format('YYYY-MM-DD HH:mm:ss') : '';
                },
            },
            {
                title: '成功数',
                dataIndex: 'successCount',
                key: 'successCount',
                sorter: (a, b) => a.successCount - b.successCount,
            },
            {
                title: '失败数',
                dataIndex: 'errorCount',
                key: 'errorCount',
                sorter: (a, b) => a.errorCount - b.errorCount,
            },
            {
                title: '协商速率',
                dataIndex: 'linkSpeed',
                key: 'linkSpeed',
                sorter: (a, b) => a.linkSpeed - b.linkSpeed,
            },
            {
                title: '下载速率',
                dataIndex: 'speed',
                key: 'speed',
                sorter: (a, b) => a.speed - b.speed,
            },
            {
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                render: (text, record, index) => {
                    return this.renderAction(text, record, index);
                },
            },
        ];

        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                    <Table
                        columns={columns}
                        dataSource={list}
                        defaultExpandAllRows={false}
                        rowSelection={rowSelection}
                        pagination={false}
                    />
                    <Row type="flex" justify="end">
                        <Pagination
                            style={{ padding: '10px 10px' }}
                            size="small"
                            showQuickJumper
                            pageSize={pageSize}
                            current={current}
                            total={total}
                            showTotal={(total, range) =>
                                `共 ${total ? total : '0'} 条记录，每页 ${pageSize} 条，这是第 ${totalPage
                                    ? current + '/' + totalPage
                                    : '1'} 页`}
                            showSizeChanger
                            pageSizeOptions={['40', '80', '120','1000']}
                            onShowSizeChange={this.handlePaginationChange}
                            onChange={this.handlePaginationChange}
                        />
                    </Row>
                </Spin>
                <Edit />
                <SetOrder />
                <SetGroup />
                <EditVersion />
                <EditAppList />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    list: state.clientList.list,
    pagination: state.clientList.pagination,
    proxyrepeatinfo: state.clientList.proxyrepeatinfo,
    uiStatus: state.clientList.uiStatus,
    agentsGroup: state.clientList.agentsGroup,
    transferData: state.clientList.transferData,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    reStart: params => dispatch(reStart(params)),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    getTransferData: data => dispatch(actions.getTransferData(data)),
    changePagination: data => dispatch(actions.changePagination(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AgencyAnalysis);






// WEBPACK FOOTER //
// ./pages/client/clientList/index.js